import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import SuccessIcon from 'components/ModalFeedbackRegister/SuccessIcon';
import StorageService from 'services/StorageService/';
import { actionsType, feedbackRegister } from 'config/constants';
import style from './style.scss'; //NOSONAR

const FeedbackRegister = ({_openDrawerPrime}) => {
    const [userName, setUserName] = useState(null);
    const userData = StorageService.getSecureItem('userData');

    useEffect(() => {
        setUserName(userData ? userData.firstName : '');

        if(typeof window !== 'undefined' && window.location.pathname.indexOf('/login-page') !== -1){
            const urlCallback = window.location && window.location.search ? window.location.search.replace('?callback=','') : '';
            window.location.href = urlCallback;
        }

        return function cleanup() {
            setTimeout(() => {
                PubSub.dispatch(actionsType.MODAL.FEEDBACK_REGISTER_CLOSE)
            }, 0)
        }
    }, []);

    const goBack = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.FEEDBACK_REGISTER_CLOSE), 0);
        _openDrawerPrime();
    }

    return (
        <div className="new-modal-container">
            <div className={'new-modal-scroll feedback-register-content active'}>
                <form className="form-container">
                    <div className="container-feedback-register">
                        <SuccessIcon />
                    </div>
                    <div className="feedback-register-container-message">
                        <label className="new-modal-title">¡Te damos la bienvenida, {userName}!</label>
                        <label className="label-warning">Tu cuenta ya ha sido creada y podrás usarla también para ingresar en  {feedbackRegister} y SPID35</label>
                    </div>

                </form>

            </div>
            <div className="modal-actions">
                <div className="cont-btn">
                    <button type="submit" className='primary-btn' onClick={goBack}>
                        <span className={'btn-span-enter'}>Ir al inicio</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FeedbackRegister;
